import React, { Component } from "react";
import { QrReader } from "react-qr-reader";
import SampleServices from "../../../services/sample.service";
import { withRouter } from "react-router-dom";
import LeftIcon from "../../../assets/images/MobileApp/logout.svg";
import { signOut } from "../../../redux/action/main";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class Scanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      _id: null,
    };
    this._isMounted = false;
    this.logOut = this.logOut.bind(this);
    this.handleResult = this.handleResult.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  logOut() {
    localStorage.removeItem("authToken");
    localStorage.clear();
    this.props.signOut();
    this.props.history !== undefined && this.props.history.replace("/");  //This ensures that the user cannot go back after logging out. clear route history stack
    // window.location.replace("/"); 

  }

  callApi = async (requestNumber) => {
    try {
      console.log("Calling API with requestNumber:", requestNumber);

      const response = await SampleServices.SampleInfo(
        "",
        requestNumber || " "
      ); // Call API

      if (response && response.status === 200) {
        const _id = response.text.data._id; // Extract ID from API response
        this.setState({ _id });

        console.log("Fetched _id:", _id);

        // Redirect to /mobileApp with _id in state
        this.props.history.push({
          pathname: "/mobileApp",
          state: { _id },
        });
      } else {
        console.error("API Error: Unexpected response", response);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  handleResult = (result, error) => {
    if (!this._isMounted) return;

    if (result) {
      try {
        console.log("Scanned QR Code:", result.text);
        const scannedData = JSON.parse(result.text); // Parse the scanned QR data
        const requestNumber = scannedData.requestNumber; // Extract requestNumber

        if (requestNumber) {
          console.log("Extracted requestNumber:", requestNumber);
          this.setState({ data: requestNumber }); // Store requestNumber
          this.callApi(requestNumber); // Call API immediately
        } else {
          console.error("QR Code does not contain a valid requestNumber.");
        }
      } catch (err) {
        console.error("Error parsing QR Code:", err);
      }
    }

    if (error) {
      console.error("QR Reader Error:", error);
    }
  };

  render() {
    return (
      <div className="qr-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5vh",
            justifyContent: "center",
            gap:"3%"
          }}
        >
          <span
            style={{
              textAlign: "center",
              color: "rgba(0, 150, 136, 1)",
              fontWeight: 900,
              fontSize: 25,
            }}
          >
            Scan Your QR Code
          </span>
          <button className="button1">
            <div className="logoutdiv" onClick={() => this.logOut()}>
              {" "}
              <img src={LeftIcon} alt="logout" className="logouticon" />
            </div>
          </button>
        </div>
        <QrReader
          className="qr-class"
          constraints={{ facingMode: "environment" }} // Use back camera if available
          onResult={this.handleResult} // Handle scan result
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators(
    {
      "signOut": signOut,
    },
    dispatch
  );
};

export default withRouter(connect(null, mapDispatchToProps)(Scanner));


// WEBPACK FOOTER //
// ./src/pages/Sample/SampleMobileApp/MobileQRScanner.js